var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-fade',[(_vm.count)?_c('div',{staticClass:"shadow-container",style:({
            zIndex: _vm.zIndex
        }),on:{"click":_vm.clickHandler}},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }